import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AppRoutingPaths } from '@wo-mc/routing';
import { authSelectors } from '@wo-mc/+state';

export const isAuthorizedGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(authSelectors.selectIsAuthorized).pipe(
    filter(isAuthorized => isAuthorized != null),
    map(isAuthorized => isAuthorized || router.createUrlTree([ AppRoutingPaths.NOT_AUTHORIZED ])),
  );
};
